import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 16px;
  height: 16px;
`

const ArrowsOpposite = ({ title = 'Arrows Opposite', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 48 48" title={title} {...rest}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.9393 4.93934C32.5251 4.35355 33.4749 4.35355 34.0607 4.93934L43.0607 13.9393C43.342 14.2206 43.5 14.6022 43.5 15C43.5 15.3978 43.342 15.7794 43.0607 16.0607L34.0607 25.0607C33.4749 25.6464 32.5251 25.6464 31.9393 25.0607C31.3536 24.4749 31.3536 23.5251 31.9393 22.9393L38.3787 16.5L15 16.5C14.1716 16.5 13.5 15.8284 13.5 15C13.5 14.1716 14.1716 13.5 15 13.5L38.3787 13.5L31.9393 7.06066C31.3536 6.47487 31.3536 5.52513 31.9393 4.93934ZM16.0607 22.9393C16.6464 23.5251 16.6464 24.4749 16.0607 25.0607L9.62132 31.5H33C33.8284 31.5 34.5 32.1716 34.5 33C34.5 33.8284 33.8284 34.5 33 34.5H9.62132L16.0607 40.9393C16.6464 41.5251 16.6464 42.4749 16.0607 43.0607C15.4749 43.6464 14.5251 43.6464 13.9393 43.0607L4.93934 34.0607C4.35355 33.4749 4.35355 32.5251 4.93934 31.9393L13.9393 22.9393C14.5251 22.3536 15.4749 22.3536 16.0607 22.9393Z"
      fill="#002AB4"
    />
  </StyledIcon>
)

ArrowsOpposite.displayName = 'ArrowsOpposite'
ArrowsOpposite.needsWork = true
export default ArrowsOpposite
